import React, { useState } from 'react';
import { FileTextIcon, SearchIcon, FilterIcon, UploadIcon, XIcon } from 'lucide-react';
import { SuccessNotification } from '../shared/SuccessNotification';
interface ContractFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
}
const ContractFormModal: React.FC<ContractFormModalProps> = ({
  isOpen,
  onClose,
  onSubmit
}) => {
  const [formData, setFormData] = useState({
    contractNo: `KTR-${new Date().getFullYear()}-${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`,
    name: '',
    vendor: '',
    value: '',
    startDate: '',
    endDate: '',
    status: 'Aktif',
    description: ''
  });
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
    setFormData({
      contractNo: `KTR-${new Date().getFullYear()}-${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`,
      name: '',
      vendor: '',
      value: '',
      startDate: '',
      endDate: '',
      status: 'Aktif',
      description: ''
    });
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-1884">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col" data-id="element-1885">
        <div className="p-4 border-b border-gray-200 flex justify-between items-center bg-neutral-light" data-id="element-1886">
          <h2 className="text-xl font-bold text-secondary flex items-center" data-id="element-1887">
            <FileTextIcon size={20} className="mr-2 text-primary" data-id="element-1888" />
            Tambah Kontrak Baru
          </h2>
          <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-200 transition-colors" data-id="element-1889">
            <XIcon size={20} className="text-gray-500" data-id="element-1890" />
          </button>
        </div>
        <div className="overflow-y-auto p-6 flex-grow" data-id="element-1891">
          <form id="contract-form" onSubmit={handleSubmit} className="space-y-4" data-id="element-1892">
            <div className="space-y-1" data-id="element-1893">
              <label className="text-sm font-medium text-gray-700" data-id="element-1894">
                No. Kontrak
              </label>
              <input type="text" value={formData.contractNo} readOnly className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 text-gray-500 text-sm cursor-not-allowed" data-id="element-1895" />
            </div>
            <div className="space-y-1" data-id="element-1896">
              <label className="text-sm font-medium text-gray-700" data-id="element-1897">
                Nama Kontrak <span className="text-red-500" data-id="element-1898">*</span>
              </label>
              <input type="text" required value={formData.name} onChange={e => setFormData({
              ...formData,
              name: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" placeholder="Contoh: Pemeliharaan Server Database" data-id="element-1899" />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1900">
              <div className="space-y-1" data-id="element-1901">
                <label className="text-sm font-medium text-gray-700" data-id="element-1902">
                  Vendor <span className="text-red-500" data-id="element-1903">*</span>
                </label>
                <input type="text" required value={formData.vendor} onChange={e => setFormData({
                ...formData,
                vendor: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" placeholder="Nama perusahaan vendor" data-id="element-1904" />
              </div>
              <div className="space-y-1" data-id="element-1905">
                <label className="text-sm font-medium text-gray-700" data-id="element-1906">
                  Nilai Kontrak
                </label>
                <div className="relative" data-id="element-1907">
                  <span className="absolute left-3 top-2 text-gray-500 text-sm" data-id="element-1908">
                    Rp
                  </span>
                  <input type="text" value={formData.value} onChange={e => setFormData({
                  ...formData,
                  value: e.target.value
                })} className="w-full pl-9 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" placeholder="0" data-id="element-1909" />
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1910">
              <div className="space-y-1" data-id="element-1911">
                <label className="text-sm font-medium text-gray-700" data-id="element-1912">
                  Tanggal Mulai <span className="text-red-500" data-id="element-1913">*</span>
                </label>
                <input type="date" required value={formData.startDate} onChange={e => setFormData({
                ...formData,
                startDate: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" data-id="element-1914" />
              </div>
              <div className="space-y-1" data-id="element-1915">
                <label className="text-sm font-medium text-gray-700" data-id="element-1916">
                  Tanggal Berakhir <span className="text-red-500" data-id="element-1917">*</span>
                </label>
                <input type="date" required value={formData.endDate} onChange={e => setFormData({
                ...formData,
                endDate: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" data-id="element-1918" />
              </div>
            </div>
            <div className="space-y-1" data-id="element-1919">
              <label className="text-sm font-medium text-gray-700" data-id="element-1920">
                Status <span className="text-red-500" data-id="element-1921">*</span>
              </label>
              <select value={formData.status} onChange={e => setFormData({
              ...formData,
              status: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" data-id="element-1922">
                <option value="Aktif" data-id="element-1923">Aktif</option>
                <option value="Akan Berakhir" data-id="element-1924">Akan Berakhir</option>
                <option value="Berakhir" data-id="element-1925">Berakhir</option>
                <option value="Dalam Perpanjangan" data-id="element-1926">Dalam Perpanjangan</option>
              </select>
            </div>
            <div className="space-y-1" data-id="element-1927">
              <label className="text-sm font-medium text-gray-700" data-id="element-1928">
                Deskripsi
              </label>
              <textarea rows={3} value={formData.description} onChange={e => setFormData({
              ...formData,
              description: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" placeholder="Lingkup pekerjaan atau catatan kontrak..." data-id="element-1929" />
            </div>
          </form>
        </div>
        <div className="p-4 border-t border-gray-200 flex justify-end space-x-2 bg-gray-50" data-id="element-1930">
          <button type="button" onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-100" data-id="element-1931">
            Batal
          </button>
          <button type="submit" form="contract-form" className="px-4 py-2 bg-primary text-secondary rounded-md text-sm font-medium hover:bg-opacity-90" data-id="element-1932">
            Simpan Kontrak
          </button>
        </div>
      </div>
    </div>;
};
export const Contracts: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [notification, setNotification] = useState({
    show: false,
    message: ''
  });
  const handleExportData = () => {
    setNotification({
      show: true,
      message: 'Data kontrak berhasil diekspor'
    });
  };
  const handleAddContract = () => {
    setIsModalOpen(true);
  };
  const handleSubmit = (data: any) => {
    setIsModalOpen(false);
    setNotification({
      show: true,
      message: `Kontrak ${data.name} berhasil ditambahkan`
    });
  };
  const handleDetail = () => {
    setNotification({
      show: true,
      message: 'Detail kontrak ditampilkan'
    });
  };
  const handleFileUpload = () => {
    setNotification({
      show: true,
      message: 'File berhasil diunggah'
    });
  };
  return <div className="space-y-4" data-id="element-1933">
      <div className="flex items-center justify-between mb-4" data-id="element-1934">
        <h1 className="text-2xl font-bold text-secondary flex items-center" data-id="element-1935">
          <FileTextIcon size={24} className="mr-2" data-id="element-1936" />
          Kontrak & Pengadaan
        </h1>
        <div className="flex space-x-2" data-id="element-1937">
          <button onClick={handleExportData} className="bg-secondary text-white px-4 py-2 rounded-md hover:bg-opacity-90" data-id="element-1938">
            Ekspor Data
          </button>
          <button onClick={handleAddContract} className="bg-primary text-secondary px-4 py-2 rounded-md hover:bg-opacity-90 font-medium" data-id="element-1939">
            + Tambah Kontrak
          </button>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-1940">
        <div className="p-4 border-b border-gray-200 flex flex-wrap gap-3 items-center justify-between" data-id="element-1941">
          <div className="relative flex-grow max-w-md" data-id="element-1942">
            <input type="text" placeholder="Cari kontrak..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" data-id="element-1943" />
            <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-1944" />
          </div>
          <div className="flex items-center gap-2" data-id="element-1945">
            <button className="flex items-center px-3 py-2 bg-gray-100 rounded-md hover:bg-gray-200" data-id="element-1946">
              <FilterIcon size={16} className="mr-1" data-id="element-1947" />
              Filter
            </button>
            <select className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" data-id="element-1948">
              <option value="" data-id="element-1949">Status Kontrak</option>
              <option value="active" data-id="element-1950">Aktif</option>
              <option value="expiring" data-id="element-1951">Akan Berakhir</option>
              <option value="expired" data-id="element-1952">Berakhir</option>
              <option value="renewal" data-id="element-1953">Dalam Perpanjangan</option>
            </select>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-1954">
          <table className="w-full" data-id="element-1955">
            <thead className="bg-neutral-light" data-id="element-1956">
              <tr data-id="element-1957">
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1958">
                  No. Kontrak
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1959">
                  Nama Kontrak
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1960">
                  Vendor
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1961">
                  Nilai
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1962">
                  Mulai
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1963">
                  Berakhir
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1964">
                  Status
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1965">
                  Dokumen
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1966">
                  Aksi
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-1967">
              <tr className="hover:bg-neutral-light" data-id="element-1968">
                <td className="px-4 py-3 text-sm text-gray-900" data-id="element-1969">
                  KTR-2023-001
                </td>
                <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-1970">
                  Pemeliharaan Server Database Utama
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1971">
                  PT Teknologi Aman
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1972">
                  Rp 350.000.000
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1973">2023-01-15</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1974">2024-01-14</td>
                <td className="px-4 py-3 text-sm" data-id="element-1975">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-1976">
                    Aktif
                  </span>
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-1977">
                  <div className="flex space-x-1" data-id="element-1978">
                    <button className="p-1 bg-blue-100 text-blue-700 rounded hover:bg-blue-200" title="TOR/KAK" data-id="element-1979">
                      <FileTextIcon size={14} data-id="element-1980" />
                    </button>
                    <button className="p-1 bg-green-100 text-green-700 rounded hover:bg-green-200" title="BAST" data-id="element-1981">
                      <FileTextIcon size={14} data-id="element-1982" />
                    </button>
                    <button className="p-1 bg-purple-100 text-purple-700 rounded hover:bg-purple-200" title="Invoice" data-id="element-1983">
                      <FileTextIcon size={14} data-id="element-1984" />
                    </button>
                  </div>
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-1985">
                  <button onClick={handleDetail} className="text-accent-info hover:underline" data-id="element-1986">
                    Detail
                  </button>
                </td>
              </tr>
              <tr className="hover:bg-neutral-light" data-id="element-1987">
                <td className="px-4 py-3 text-sm text-gray-900" data-id="element-1988">
                  KTR-2023-002
                </td>
                <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-1989">
                  Lisensi Oracle BINDA Jatim
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1990">
                  PT Data Solusi
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1991">
                  Rp 275.000.000
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1992">2022-09-30</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1993">2023-09-29</td>
                <td className="px-4 py-3 text-sm" data-id="element-1994">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800" data-id="element-1995">
                    Akan Berakhir
                  </span>
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-1996">
                  <div className="flex space-x-1" data-id="element-1997">
                    <button className="p-1 bg-blue-100 text-blue-700 rounded hover:bg-blue-200" title="TOR/KAK" data-id="element-1998">
                      <FileTextIcon size={14} data-id="element-1999" />
                    </button>
                    <button className="p-1 bg-green-100 text-green-700 rounded hover:bg-green-200" title="BAST" data-id="element-2000">
                      <FileTextIcon size={14} data-id="element-2001" />
                    </button>
                  </div>
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-2002">
                  <button onClick={handleDetail} className="text-accent-info hover:underline" data-id="element-2003">
                    Detail
                  </button>
                </td>
              </tr>
              <tr className="hover:bg-neutral-light" data-id="element-2004">
                <td className="px-4 py-3 text-sm text-gray-900" data-id="element-2005">
                  KTR-2022-015
                </td>
                <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-2006">
                  Pengadaan Kendaraan Taktis BINDA Sumbar
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-2007">
                  PT Otomotive Taktis
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-2008">
                  Rp 1.250.000.000
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-2009">2022-05-10</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-2010">2025-05-09</td>
                <td className="px-4 py-3 text-sm" data-id="element-2011">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-2012">
                    Aktif
                  </span>
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-2013">
                  <div className="flex space-x-1" data-id="element-2014">
                    <button className="p-1 bg-blue-100 text-blue-700 rounded hover:bg-blue-200" title="TOR/KAK" data-id="element-2015">
                      <FileTextIcon size={14} data-id="element-2016" />
                    </button>
                    <button className="p-1 bg-green-100 text-green-700 rounded hover:bg-green-200" title="BAST" data-id="element-2017">
                      <FileTextIcon size={14} data-id="element-2018" />
                    </button>
                    <button className="p-1 bg-purple-100 text-purple-700 rounded hover:bg-purple-200" title="Invoice" data-id="element-2019">
                      <FileTextIcon size={14} data-id="element-2020" />
                    </button>
                  </div>
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-2021">
                  <button onClick={handleDetail} className="text-accent-info hover:underline" data-id="element-2022">
                    Detail
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="px-4 py-3 border-t border-gray-200 flex items-center justify-between" data-id="element-2023">
          <div className="text-sm text-gray-700" data-id="element-2024">
            Menampilkan 3 dari 78 kontrak
          </div>
          <div className="flex items-center space-x-2" data-id="element-2025">
            <button className="px-3 py-1 border border-gray-300 rounded-md text-sm disabled:opacity-50" data-id="element-2026">
              Sebelumnya
            </button>
            <button className="px-3 py-1 bg-secondary text-white rounded-md text-sm" data-id="element-2027">
              1
            </button>
            <button className="px-3 py-1 border border-gray-300 rounded-md text-sm" data-id="element-2028">
              2
            </button>
            <button className="px-3 py-1 border border-gray-300 rounded-md text-sm" data-id="element-2029">
              3
            </button>
            <button className="px-3 py-1 border border-gray-300 rounded-md text-sm" data-id="element-2030">
              Berikutnya
            </button>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-2031">
        <div className="p-3 border-b border-gray-200 bg-neutral-light" data-id="element-2032">
          <h2 className="font-bold text-secondary flex items-center" data-id="element-2033">
            <UploadIcon size={18} className="mr-2" data-id="element-2034" />
            Unggah Dokumen Kontrak
          </h2>
        </div>
        <div className="p-4" data-id="element-2035">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-2036">
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 flex flex-col items-center justify-center" data-id="element-2037">
              <div className="bg-blue-50 p-2 rounded-full mb-2" data-id="element-2038">
                <FileTextIcon size={24} className="text-accent-info" data-id="element-2039" />
              </div>
              <h3 className="font-medium text-secondary text-sm mb-1" data-id="element-2040">
                TOR/KAK
              </h3>
              <p className="text-xs text-gray-600 text-center mb-3" data-id="element-2041">
                Unggah dokumen TOR/KAK dalam format PDF
              </p>
              <button onClick={handleFileUpload} className="bg-accent-info text-white px-3 py-1.5 rounded text-sm hover:bg-opacity-90" data-id="element-2042">
                Pilih File
              </button>
            </div>
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 flex flex-col items-center justify-center" data-id="element-2043">
              <div className="bg-green-50 p-2 rounded-full mb-2" data-id="element-2044">
                <FileTextIcon size={24} className="text-accent-green" data-id="element-2045" />
              </div>
              <h3 className="font-medium text-secondary text-sm mb-1" data-id="element-2046">BAST</h3>
              <p className="text-xs text-gray-600 text-center mb-3" data-id="element-2047">
                Unggah dokumen BAST dalam format PDF
              </p>
              <button onClick={handleFileUpload} className="bg-accent-green text-white px-3 py-1.5 rounded text-sm hover:bg-opacity-90" data-id="element-2048">
                Pilih File
              </button>
            </div>
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 flex flex-col items-center justify-center" data-id="element-2049">
              <div className="bg-purple-50 p-2 rounded-full mb-2" data-id="element-2050">
                <FileTextIcon size={24} className="text-purple-600" data-id="element-2051" />
              </div>
              <h3 className="font-medium text-secondary text-sm mb-1" data-id="element-2052">
                Invoice
              </h3>
              <p className="text-xs text-gray-600 text-center mb-3" data-id="element-2053">
                Unggah dokumen invoice dalam format PDF
              </p>
              <button onClick={handleFileUpload} className="bg-purple-600 text-white px-3 py-1.5 rounded text-sm hover:bg-opacity-90" data-id="element-2054">
                Pilih File
              </button>
            </div>
          </div>
        </div>
      </div>

      <ContractFormModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSubmit={handleSubmit} data-id="element-2055" />

      <SuccessNotification message={notification.message} isVisible={notification.show} onClose={() => setNotification({
      ...notification,
      show: false
    })} data-id="element-2056" />
    </div>;
};